import { MuiComponent } from "./type";
import * as Colors from "../colors";

export const MuiTooltip: MuiComponent<"MuiTooltip"> = {
  styleOverrides: {
    tooltip: {
      marginTop: "12px",
      backgroundColor: Colors.Selected,
      borderRadius: "12px",
      color: "#fff",
      padding: "8px 12px",
      boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.4)",
      minWidth: "250px",
      border: `1px solid ${Colors.Selected}`,
      position: "relative",
      width: "fit-content",
      overflow: "visible",

      "&::before": {
        content: '""',
        position: "absolute",
        top: "-7px",
        left: "50%",
        transform: "translateX(-50%) rotate(45deg)",
        width: "12px",
        height: "12px",
        backgroundColor: Colors.Selected,
        borderLeft: `1px solid ${Colors.Selected}`,
        borderTop: `1px solid ${Colors.Selected}`,
        zIndex: 10,
      },
    },
  },
};
